// extracted by mini-css-extract-plugin
module.exports = {"wrap":"InhabitantTaxOfRetirementSection__wrap--12l0D","table":"InhabitantTaxOfRetirementSection__table--2pjjC"};